import { OverlayRef } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';

export class DeSnackbarRef {
  constructor(private readonly overlay: OverlayRef) {
   }

public onLinkClick: Observable<string>;

  public close() {
    this.overlay.dispose();
  }

 public isVisible() {
    return this.overlay && this.overlay.overlayElement;
  }

  public getPosition() {
    return this.overlay.overlayElement.getBoundingClientRect();
  }

}
